import { FormProvider } from "react-hook-form";

import { SVGSprite } from "@/components/Atoms";
import FormInputs from "@/components/Organisms/HookFormInputs/V1";
import Typography from "@/foundation/Typography/V2";

import useBookConsultationForm from "./useBookConsultationForm";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BookConsultationForm.module.scss";

interface BookConsultationFormProps {}

const BookConsultationForm: React.FC<BookConsultationFormProps> = () => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const { bookConsultationForm } = data;
  const { title } = bookConsultationForm || {};

  const {
    isFormSubmitted,
    methods,
    isLoading,
    onBlur,
    requestCallbackHandler,
  } = useBookConsultationForm();

  const components = [
    {
      name: "name",
      props: {
        name: "name",
        className: cls("name"),
      },
    },
    {
      name: "phone",
      props: {
        name: "mobile",
        className: cls("phone"),
        onBlur,
      },
    },
    {
      name: "infoText",
      props: {
        children: (
          <Typography className={cls("infoText")} variant="paragraph1">
            {"You'll get a call back in 24 hours!"}
          </Typography>
        ),
      },
    },
    {
      name: "submit",
      props: {
        children: isFormSubmitted ? (
          <>
            <SVGSprite icon="icon-details-submitted" />
            Details Submitted
          </>
        ) : (
          "Submit"
        ),
        className: clsx(
          cls("submitButton"),
          isFormSubmitted ? cls("submitted") : ""
        ),
        isLoading,
      },
    },
  ];

  return (
    <div className={cls("bookConsultationForm")}>
      <div className={cls("header")}>
        <Typography
          variant="heading2"
          className={cls("title")}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={cls("iconWrapper")}>
          <SVGSprite className={cls("icon")} icon="icon-bootcamp-phone" />
        </div>
      </div>
      <FormProvider {...methods}>
        <form className={cls("formWrapper")} onSubmit={requestCallbackHandler}>
          <FormInputs components={components} />
        </form>
      </FormProvider>
    </div>
  );
};

export default BookConsultationForm;
